import React from 'react';
import get from 'lodash/get';

import BackgroundView from './BackgroundView.react';
import ContentView from './ContentView.react';
import Browser from '../util/Browser';
import Payload from '../util/Payload';

class EngagementApp extends React.Component {
  closeAdButtonStyle = {
    display: 'none',
  };
  constructor(props) {
    super(props);
    console.log('EngagementApp.constructor()');
    console.log(
      'currentAdIndex',
      this.props.adsControl.currentAdIndex(),
      'currentAd',
      this.props.adsControl.currentAd()
    );
    this.state = this.getInitialState();
    this.dismissalStartLogged = false; // Track if E2_DISMISSAL_START has been logged
  }

  getInitialState = () => ({
    open: false,
    iframePixelsFired: false,
    didFinishShowCalled: false,
  });

  componentWillMount() {
    window.addEventListener('message', this.postMessageReceiver);
    window.addEventListener('resize', this.updateComponentDimensions);
    if (Browser.simulateSdk() || this.props.adsControl.currentAdIndex() !== 0) {
      console.log(
        '>> EngagementApp.componentWillMount() - calling window.prepareToShow because one of the following is true:'
      );
      console.log('Browser.simulateSdk()', Browser.simulateSdk());
      console.log(
        'this.props.adsControl.currentAdIndex() !== 0',
        this.props.adsControl.currentAdIndex()
      );
      window.prepareToShow();
    }
    this.updateComponentDimensions();
    this.doLoad();
  }

  componentDidMount() {
    if (Browser.simulateSdk() || this.props.adsControl.currentAdIndex() !== 0) {
      console.log(
        '>> EngagementApp.componentDidMount() - calling window.prepareToShow because one of the following is true:'
      );
      console.log('Browser.simulateSdk()', Browser.simulateSdk());
      console.log(
        'this.props.adsControl.currentAdIndex() !== 0',
        this.props.adsControl.currentAdIndex()
      );
      window.show();
    }
    // window.show(); // Uncomment this line if you want to test locally on your device with no SDK
  }

  componentWillUnmount() {
    // Clear didFinishShow timeout if component unmounts
    if (this.didFinishShowTimeout) {
      clearTimeout(this.didFinishShowTimeout);
      this.didFinishShowTimeout = null;
    }

    // SAFETY: If didFinishShow was never called but app was shown, call it now
    // This ensures SDK is notified even if component unmounts early (e.g., WebView destroyed)
    // Only call if:
    // 1. didFinishShow was never called
    // 2. App was actually shown (open === true)
    // 3. No iframe error occurred (would indicate failure, not success)
    // Note: this.iframeError might be undefined if doLoad() never ran, so use || false
    if (!this.state.didFinishShowCalled && this.state.open && !(this.iframeError || false)) {
      console.warn('EngagementApp.componentWillUnmount - didFinishShow never called but app was open, calling now as safety measure');
      try {
        this.props.didFinishShow();
      } catch (e) {
        console.error('EngagementApp.componentWillUnmount - Error calling didFinishShow:', e);
      }
    }

    window.removeEventListener('message', this.postMessageReceiver);
    window.removeEventListener('resize', this.updateComponentDimensions);
  }

  isReadyToOpen = () => {
    console.log('isReadyToOpen(), Ready to open');
    return this.setState({ open: true }, this.didFinishShow);
  };

  doLoad = () => {
    console.log('Doing load', 'doLoad()');
    this.iframeError = this.iframeError || false;

    // logging to server
    window.server.logForImprIds('EngagementApp_mounted');

    this.updateComponentDimensions();

    if (this.props.on) {
      this.props.on('app_opened', () => {
        console.log('App is opened, setting open to true and calling didFinishShow');
        return this.setState({ open: true }, this.didFinishShow);
      });
    }
  };

  didFinishShow = () => {
    console.log('>> EngagementApp.didFinishShow()');

    // FIX: Early return if already called to prevent multiple calls
    if (this.state.didFinishShowCalled) {
      console.log('>> EngagementApp.didFinishShow() - already called, skipping');
      return;
    }

    // Clear any existing timeout to prevent multiple timeouts
    if (this.didFinishShowTimeout) {
      clearTimeout(this.didFinishShowTimeout);
      this.didFinishShowTimeout = null;
    }

    // must have a condition on unhandled m2m://interstitial urls for ios,
    // as ios will not cancel the request loading the same way android does.
    if (!Browser.isIOS()) {
      // voodoo below... without this dummy call, the e2 app dies a horrible
      // death in android.  there must be an m2m://interstitial href at this
      // point elsewise all pending requests end up canceled and the e2 app
      // displays empty on the screen.  not sure why yet.
      // deferring didFinishShow is so that moatad.js can be loaded prior to the
      // om impression event triggered from the android/ios layer
      window.server.notifySdk('ignoreThis');
    }

    // if the iframe pixels have already fired, and we haven't called it yet,
    // then do so now
    if (this.state.iframePixelsFired) {
      console.log('>> EngagementApp.didFinishShow() - pixels already fired, calling immediately');
      this.props.didFinishShow();
      this.setState({ didFinishShowCalled: true });
      return;
    }

    // this is called on app_open, so if we don't get the pels fired
    // in 500ms, then go ahead and call finish show so we don't miss
    // an opportunity
    this.didFinishShowTimeout = setTimeout(() => {
      // Use functional setState to check current state (prevents race conditions)
      this.setState(prevState => {
        if (!prevState.didFinishShowCalled) {
          console.warn('EngagementApp - calling didFinishShow in timeout');
          this.props.didFinishShow();
          return { didFinishShowCalled: true };
        }
        return null;
      });
      this.didFinishShowTimeout = null;
    }, 500);
  };

  didFinishLoad = (event, iframeError) => {
    if (iframeError) {
      this.handleIframeError(event);
    }

    this.props.didFinishLoad();
  };

  /*
    Prevent E2 from opening if Card iframe load error during preload.
  */
  handleIframeError = event => {
    console.log('engagementApp.handleIframeError - error loading iframe card.');
    this.iframeError = true;

    // Get impression_id from payload (Option B pattern)
    const queueInterstitial = Payload.findAction(
      Payload.getActionsInPayload(get(this.props, 'payload', {})),
      'queue_interstitial'
    )[0];
    const impressionId = get(queueInterstitial, 'impression_id');

    if (impressionId) {
      window.server.log({
        tag: 'E2_IFRAME_ERROR',
        fn: 'EngagementApp.handleIframeError',
        msg: 'Iframe load error - setting open to false',
        inmarketParams: {
          m2m_impr_id: impressionId,
        },
        source: 'ERROR',
      });
    } else {
      window.server.log({
        tag: 'E2_IFRAME_ERROR',
        fn: 'EngagementApp.handleIframeError',
        msg: 'Iframe load error - setting open to false',
        source: 'ERROR',
      });
    }

    this.setState({ open: false });
    window.server.notifySdk('didFinishLoadWithError?message=Could not load ad');
    return true;
  };

  updateComponentDimensions = () => {
    const screenWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    const screenHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    console.log(`resize, new screenWidth: ${screenWidth}, screenHeight: ${screenHeight}`);
    this.setState({ screenWidth, screenHeight });
  };

  doClose = () => {
    try {
      const dismissalSource = window._dismissalSource || 'UNKNOWN';

      // PERFORMANCE FIX: Close UI immediately, defer logging to next tick
      // This prevents synchronous logging from blocking the UI update
      if (Browser.isIOS()) {
        const queueInterstitial = Payload.findAction(
          Payload.getActionsInPayload(get(this.props, 'payload', {})),
          'queue_interstitial'
        )[0];
        if (get(queueInterstitial, 'omSdkVerify')) {
          const { didFinishStartHide } = this.props;
          console.warn('ContentView - calling didFinishStartHide');
          this.props.didFinishStartHide();
        } else {
          this.setState({ open: false });
        }
      } else {
        // Close UI immediately for non-iOS
        this.setState({ open: false });
      }

      // Defer logging to next tick to avoid blocking UI update
      // Always log dismissal start - critical for tracking dismissal flow
      // But only log once to prevent duplicate entries
      if (!this.dismissalStartLogged) {
        this.dismissalStartLogged = true;

        // Use setTimeout to defer expensive logging operations
        setTimeout(() => {
          try {
            const queueInterstitial = Payload.findAction(
              Payload.getActionsInPayload(get(this.props, 'payload', {})),
              'queue_interstitial'
            )[0];
            const impressionId = get(queueInterstitial, 'impression_id');

            // Try to get impression_id from ads if not available in queueInterstitial (Option B pattern)
            let finalImpressionId = impressionId;
            if (!finalImpressionId) {
              const ads = Payload.findAdsInPayload(get(this.props, 'payload', {}));
              if (ads.length > 0) {
                finalImpressionId = ads[0].impression_id;
              }
            }

            // Simplified diagnostic context - only essential flags to reduce overhead
            const diagnosticContext = {
              iframePixelsFired: this.state.iframePixelsFired || false,
              didFinishShowCalled: this.state.didFinishShowCalled || false,
              wasEverOpen: this.state.open || false,
            };

            window.server.log({
              tag: 'E2_DISMISSAL_START',
              fn: 'EngagementApp.doClose',
              msg: 'doClose() called',
              inmarketParams: finalImpressionId ? {
                m2m_impr_id: finalImpressionId,
              } : {},
              source: dismissalSource,
              omSdkVerify: get(queueInterstitial, 'omSdkVerify') || false,
              dismissedType: get(queueInterstitial, 'dismissed.type') || null,
              isIOS: Browser.isIOS(),
              hasQueueInterstitial: !!queueInterstitial,
              // Simplified diagnostic context
              diagnostic: diagnosticContext,
            });
          } catch (logError) {
            console.error('Error logging dismissal:', logError);
          }
        }, 0);
      }

      // Reset source after logging
      window._dismissalSource = null;
    } catch (e) {
      // Close UI even on error
      this.setState({ open: false });

      // Defer error logging too
      setTimeout(() => {
        window.server.log({
          tag: 'E2_DISMISSAL_ERROR',
          fn: 'EngagementApp.doClose',
          msg: `Error in doClose: ${e.message}`,
          error: e.toString(),
        });
      }, 0);
    }
  };

  clickCloseAdButton = () => {
    // This is called by actionForCloseInitiated() on iOS
    // It should NOT trigger HeaderBar.onClickClose - it's a separate button
    // But we need to ensure it doesn't cause duplicate close flows
    console.log('EngagementApp.clickCloseAdButton() called');

    // Best-effort unload attribution marker (SDK initiated close button click on iOS)
    try {
      window.__e2UnloadAttribution = window.__e2UnloadAttribution || { version: 1, events: {} };
      window.__e2UnloadAttribution.events.E2_SDK_CLOSE_BUTTON_CLICK = {
        atMs: Date.now(),
        atIso: new Date().toISOString(),
      };
    } catch (e) {
      // no-op
    }

    // Log this call to track if it's being called multiple times
    if (window.server && window.server.foreachAd) {
      window.server.foreachAd(ad => {
        window.server.log({
          tag: 'E2_INTERNAL',
          fn: 'EngagementApp.clickCloseAdButton',
          msg: 'clickCloseAdButton() called (iOS SDK initiated via actionForCloseInitiated)',
          inmarketParams: {
            m2m_impr_id: ad.impression_id,
          },
        });
      });
    }

    this.setState({ open: false });
  };

  postMessageReceiver = event => {
    console.log('>> EngagementApp.postMessageReceiver()');
    if (typeof event.data !== 'string' || event.data.indexOf('react-devtools') !== -1) {
      return;
    }

    console.warn('>> EngagementApp - MessageEvent: ');
    console.warn(JSON.stringify(event));

    try {
      const data = JSON.parse(event.data);
      if (!data.action || !data.m2m_impr_id) {
        return;
      }

      if (get(data, 'action', '') === 'close_e2') {
        // Close e2. Sent from surveygizmo
        window.server.log({
          tag: 'E2_IFRAME_CLOSE_E2_MESSAGE',
          fn: 'EngagementApp.postMessageReceiver',
          msg: 'Iframe sent close_e2 action',
          inmarketParams: {
            m2m_impr_id: data.m2m_impr_id,
          },
          data,
        });
        window._dismissalSource = 'E2_IFRAME_CLOSE_E2';
        this.doClose();
      }

      if (data.action === 'iframe_pixels_fired') {
        console.log('Found iframe_pixels_fired');

        const toState = { iframePixelsFired: true };

        // FIX: Clear timeout if pixels fire before timeout
        if (this.didFinishShowTimeout) {
          clearTimeout(this.didFinishShowTimeout);
          this.didFinishShowTimeout = null;
        }

        // if the app is open and we receive this event,
        // then that means third_party_impr_pels.js has fired
        // it's pixels and we can go ahead and notify the
        // sdk that we're showing the ad.
        if (this.state.open && !this.state.didFinishShowCalled) {
          console.log('>> EngagementApp.postMessageReceiver - pixels fired, calling didFinishShow');
          this.props.didFinishShow();
          toState.didFinishShowCalled = true;
        }

        this.setState(toState);
      }
    } catch (e) { }
  };

  render() {
    const { adsControl, didFinishHide, currentAdIndex, didFinishStartHide } = this.props;
    return (
      <div>
        <BackgroundView />
        <ContentView
          adsControl={adsControl}
          currentAdIndex={currentAdIndex}
          isReadyToOpen={this.isReadyToOpen}
          doClose={this.doClose}
          width={this.state.screenWidth}
          height={this.state.screenHeight}
          didFinishHide={didFinishHide}
          didFinishStartHide={didFinishStartHide}
          didFinishLoad={this.didFinishLoad}
          actions={Payload.getActionsInPayload(get(this.props, 'payload', {}))}
          fields={Payload.getFieldsInPayload(get(this.props, 'payload', {}))}
          open={this.state.open}
        />
        <button
          type="button"
          id="closeAdButton"
          name="closeAdButton"
          aria-label="closeAdButton"
          style={{ ...this.closeAdButtonStyle }}
          onTouchStart={this.clickCloseAdButton}
          onClick={this.clickCloseAdButton}
        ></button>
      </div>
    );
  }
}

export default EngagementApp;
